import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Action, Article, Task, Story } from "../types";
import "./AddPostModal.css";
import { getActionList } from "../api/taskApi";
import { getArticles } from "../api/articleApi";
import { getStories } from "../api/storyApi";

interface AddPostModalProps {
  isOpen: boolean;
  selectedDate: Date | null;
  onClose: () => void;
  onSave: (data: any) => void;
  selectedTask: Task | null;
}

const initialState = {
  action: "",
  actionId: "",
  articleId: 0,
  time: "00:00"
};

export default function AddPostModal({ isOpen, onClose, onSave, selectedDate, selectedTask }: AddPostModalProps) {
  const [action, setAction] = useState(initialState.action);
  const [actionId, setActionId] = useState(initialState.actionId);
  const [articleId, setArticleId] = useState(initialState.articleId);
  const [articles, setArticles] = useState<(Article | Story)[]>([]);
  const [articlesFiltered, setArticlesFiltered] = useState<(Article | Story)[]>([]);
  const [showPublished, setShowPublished] = useState(false);
  const [actionList, setActionList] = useState<Action[]>([]);
  const [stories, setStories] = useState<Story[]>([]);

  useEffect(() => {
    if (selectedTask) {
      const theTime = selectedTask.datetimePlanned || new Date();
      const selectedHourMin = `${theTime.getHours().toString().padStart(2, "0")}:${theTime.getMinutes().toString().padStart(2, "0")}`;

      setAction(selectedTask.actionLabel);
      setActionId(selectedTask.actionId);

      setArticleId(selectedTask.article.id);
      setTime(selectedHourMin);
    } else {
      resetInitialState();
    }
  }, [selectedTask]);

  useEffect(() => {
    getActionList().then((actionList) => {
      setActionList(actionList);
    });
  }, []);

  useEffect(() => {
    console.log("actionId", actionId);
    if (parseInt(actionId) === 3 || parseInt(actionId) === 4) {
      getStories(1, { id: 'created_at', desc: true }, { 'deleted_at': null }).then((storyList) => {
        console.log("storyList", storyList);
        setStories(storyList.data);
        setArticlesFiltered(storyList.data);
        if (selectedTask && selectedTask.article) {
          setArticleId(selectedTask.article.id);
        }
      });
    } else {
      getArticles(1, { id: 'created_at', desc: true }, { 'deleted_at': null }).then((articleList) => {
        console.log("articleList", articleList);
        setArticles(articleList.data);
        setArticlesFiltered(articleList.data);
        if (selectedTask && selectedTask.article) {
          setArticleId(selectedTask.article.id);
        }
      });
    }
  }, [actionId, selectedTask]);

  useEffect(() => {
    const isStoryAction = parseInt(actionId) === 3 || parseInt(actionId) === 4;
    const sourceData = isStoryAction ? stories : articles;
    const filteredData = showPublished 
      ? sourceData 
      : sourceData.filter(item => item.isPublished === false);

    setArticlesFiltered(filteredData);
  }, [showPublished, actionId, stories, articles]);

  const [time, setTime] = useState(initialState.time);

  const resetInitialState = () => {
    setAction(initialState.action);
    setActionId(initialState.actionId);
    setArticleId(initialState.articleId);
    setTime(initialState.time);
  };

  const handleArticleSelect = (article: Article | Story) => {
    setArticleId(article.id);
  };

  const handleSave = () => {
    const date = selectedDate ? new Date(selectedDate) : new Date();
    const [hours, minutes] = time.split(":").map(Number);
    date.setHours(hours);
    date.setMinutes(minutes);

    const selectedArticle = articlesFiltered.find((article) => article.id === articleId);
    if (!selectedArticle) return;

    const newTask: Task = {
      id: selectedTask ? selectedTask.id : -1,
      datetimePlanned: date,
      datetimePublished: null,
      actionLabel: action,
      actionId: actionId,
      userId: 'null', // todo: remove from dto
      article: selectedArticle
    };

    resetInitialState();
    onSave(newTask);
  };

  const handleSelectTarea = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = Number(e.target.value);
    const selectedLabel = actionList.find((action: Action) => action.id === selectedValue)?.label || "";

    setAction(selectedLabel);
    setActionId(e.target.value);
  };

  const handleSelectArticulo = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setArticleId(Number(e.target.value));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => { resetInitialState(); onClose(); }}
      title={selectedTask ? "Modificar tarea" : "Agregar tarea"}
    >
      <div className="add-post-modal">
        <label>
          Tarea:
          <select
            value={actionId}
            onChange={handleSelectTarea}
            style={{ fontSize: "22px" }}
          >
            <option key='-' value=''>
              Selecciona una acción
            </option>
            {actionList.map((action: Action) => (
              <option key={action.id} value={action.id}>
                {action.label}
              </option>
            ))}
          </select>
        </label>

        <label>
          Artículo:
          <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '5px' }}>
            <span style={{ fontSize: '14px', width: '140px' }}>Mostrar publicados</span>
            <input
              type="checkbox"
              onChange={(e) => setShowPublished(e.target.checked)}
              style={{ width: 'auto', marginLeft: '5px' }}
            />
          </div>
        </label>
        
        <select
          value={articleId}
          onChange={handleSelectArticulo}
          style={{ fontSize: "22px" }}
        >
          <option key='-' value=''>
            Selecciona un artículo
          </option>
          {articlesFiltered.map((article) => (
            <option key={article.id} value={article.id}>
              {article.title}
            </option>
          ))}
        </select>

        <label>
          Hora:<br />
          <span style={{ fontSize: "14px", color: "#666" }}>(se redondea a los 5 minutos)</span>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            onBlur={(e) => {
              const [hours, minutes] = e.target.value.split(":").map(Number);
              let roundedMinutes = Math.round(minutes / 5) * 5;
              let newHours = hours;
              if (roundedMinutes === 60) {
                roundedMinutes = 0;
                newHours = (newHours + 1) % 24;
              }
              const newTime = `${String(newHours).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}`;
              setTime(newTime);
            }}
            style={{ fontSize: "22px" }}
          />
        </label>
        <button onClick={handleSave}>Save</button>
      </div>
    </Modal>
  );
}
